import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationPassDowns.ts
function useLocationPassDowns(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationPassDownsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.locationId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationPassDowns };

//# sourceMappingURL=useLocationPassDowns.js.map